import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../components/Header/Header";
import payowner from "../../../interfaces/payowner-info";
import styles from "./CreditReview.module.scss";
import visa from "../../../resources/images/visacard.png";
import mc from "../../../resources/images/mastercard.png";
import amex from "../../../resources/images/amexcard.png";
import discover from "../../../resources/images/discovercard.png";
import useGetCybersourceToken from "../../../hooks/useGetCbsSignature";
import cybersourceSignature from "../../../interfaces/cybersource-signature";
import CreditCard from "../../../interfaces/credit-fields";
import ccpic from "../../../resources/images/CC.svg";
import analyticsService from "../../../services/analytics/analyticsService";
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha
} from "react-google-recaptcha-v3";
import { ConfigContext } from "../../../providers/ConfigContext";
import useGetRecaptcha from "../../../hooks/useGetRecaptcha";

function CreditReview(props: any) {
  const navigate = useNavigate();
  const [getToken] = useGetCybersourceToken();
  const [getRecaptcha] = useGetRecaptcha();
  const [loading, setLoading] = useState(true);
  const [displayError, setDisplayError] = useState(false);
  const [captchaPass, setCaptchaPass] = useState(true);
  const [refreshReCaptcha, setRefreshRecaptcha] = useState(false);
  const [allowClick, setAllowClick] = useState(true);
  const [timer, setTimer] = useState(true);
  const { version } = props;
  const { cbsUrl, reCaptchaSiteKey } = useContext(ConfigContext);
  const location = useLocation();
  let dumble = new analyticsService();
  
  const {
    paymentAmt, firstName, lastName,
  } = location.state as payowner;

  const { 
    cardCvn, cardExpiration, cardNumber, cardType, cbsCardType,
  } = location.state as CreditCard;

  const [cbsSign, setCbsSign] = useState<cybersourceSignature>({});

  const showHeader = () => {
    if (version === "creditcard") {
      return <Header name="Finalize Your Payment" redirect="/creditcardpayment.html" />;
    }
    return <br/>;
  };

  const displayPaymentInfo = () => {
    const four = cardNumber.substring(cardNumber.length - 4, cardNumber.length);
    const x = `${cardType} ending in ${four}`;
    const name = `${firstName} ${lastName}`;
    return (
      <div className={styles.display}>
        <div className={styles.creditInfo}>
          {x}
        </div>
        <div>
          {name}
        </div>
      </div>
    );
  };

  const displayPaymentAmount = () => {
    if (version === "creditcard") {
      return(
        <div className={styles.spacing}>
          <div className={styles.info}>
            <h3>Amount</h3>
            <h3>
              {`$${paymentAmt}`}
            </h3>
          </div>
        </div>
      )
    }
    return(
      <div className={styles.payment}>
        <img src={ccpic} alt="credit card" className={styles.svgCC} />
        <h3>Finalize Payment</h3>
        <h5>Balance due: $amount</h5>
      </div>
    )
  };

  const displayCreditPic = () => {
    let x;
    if (cardType === "Visa") {
      x = visa;
    } else if (cardType === "Mastercard") {
      x = mc;
    } else if (cardType === "Discover") {
      x = discover;
    } else if (cardType === "American Express") {
      x = amex;
    }
    return (
      <img src={x} className={styles.image} alt={cardType} />
    );
  };

  const displayEditPayment = () => {
    if (version === "remit") {
      return(
        <div className={`${styles.spacing} ${styles.edit}`} onClick={() => navigate("/remitpayment.html")}>Edit Payment</div>
      )
    }
    return null;
  }

  const errorMessage = (type: string) => {
    if (type === "edit"){
      return(
        <div className={styles.error}>
          Please take a moment to verify that your payment information is correct
            or try a different payment method.
        </div>
      )
    }
   return(
    <div className={styles.timererror}>
      Sorry, something went wrong. Please try again.
    </div>
   ) 

  };

  const requestCbsSign = async () => {
    const cbsSignature= {
      amount: paymentAmt.replaceAll(",", ""),
      billToForename: firstName,
      billToSurname: lastName,
    }
    await callGetSign(cbsSignature);
 }

  // request signature with signed fields
  const callGetSign = async (payload: cybersourceSignature) =>{
    let val: string;
    version === "remit" ? val = "remit" : val = "sale";
    const { data, error } = await getToken(payload, val);
    if (error){
      console.log(error);
      return;
    } else if (data != null) {
      setCbsSign(data);
    }
  }

  useEffect(() => {
    dumble.initDumblePage("Payment Portal:Credit Card:Payment Review");
  }, []);

  useEffect(() => {
    if (displayError === true) dumble.initDumblePage("Payment Portal:Credit Card:Payment Error");
  }, [displayError]);
  
  useEffect(() => {
    requestCbsSign();
  }, []);

  useEffect(() => {
    setLoading(false);
  }, [cbsSign]);

  useEffect(() =>{
    displayView();
  }, [displayError]);

  const handleRecaptcha = async (value: string) => {
    const {data, error} = await getRecaptcha(value);
    if (error){
      console.log(error);
    } else if (data != null){
      if ((data.status).toLowerCase() !== "success") setCaptchaPass(false);
    }
  }

  (window as any).processRequest = (statusCode: any) => {
    setTimer(false);
    setAllowClick(true);
    if (statusCode && statusCode === 200){
      const orderId = cbsSign.transactionUuid;
      navigate("/creditcardpayment/confirmation.html", {
        state: {
          payAmt: paymentAmt,
          cardType: cardType,
          orderId: orderId,
        },
      })
    } else{
      // 401 error or stuffs
      setDisplayError(true);
    }
  };

  const allowClickTimer = () => {
    setAllowClick(false);
    if (timer){
      const timeout = setTimeout(function () {
        try{
          setAllowClick(true);
          setDisplayError(true);
          setRefreshRecaptcha(recaptcha => ! recaptcha);
        } catch (error) {
          console.log(error);
        }
      }, 2000);
      return () => clearTimeout(timeout);
    }
  }
  
  const load = (type: string) => {

   if (!loading) {
      return(
        <div className={styles.displayCC}>
          <iframe name="cc-ui" id="cc-ui" title = "cc ui" >
          </iframe>
          <form 
            className={styles.form} 
            action={cbsUrl}
            onSubmit={()=> allowClickTimer()}
            method="POST" 
            target="cc-ui"
            >          
              {/* signed */}
              <input type="text" name="access_key" id={cbsSign.accessKey} value={cbsSign.accessKey} readOnly hidden></input>
              <input type="text" name="amount" id={cbsSign.amount} value={cbsSign.amount} readOnly hidden></input>
              
              <input type="text" name="bill_to_address_country" id={cbsSign.billToAddressCountry} value={cbsSign.billToAddressCountry} readOnly hidden></input>
              <input type="text" name="bill_to_email" id={cbsSign.billToEmail} value={cbsSign.billToEmail} readOnly hidden></input>
              <input type="text" name="bill_to_forename"id={cbsSign.billToForename} value={cbsSign.billToForename} readOnly hidden></input>
              <input type="text" name="bill_to_surname" id={cbsSign.billToSurname} value={cbsSign.billToSurname} readOnly hidden></input>
              <input type="text" name="currency" id={cbsSign.currency} value={cbsSign.currency} readOnly hidden></input>
              <input type="text" name="ignore_avs" id={cbsSign.ignoreAvs} value={cbsSign.ignoreAvs} readOnly hidden></input>
              <input type="text" name="locale" id={cbsSign.locale} value={cbsSign.locale} readOnly hidden></input>
              <input type="text" name="profile_id" id={cbsSign.profileId} value={cbsSign.profileId} readOnly hidden></input>
              <input type="text" name="reference_number" id={cbsSign.referenceNumber} value={cbsSign.referenceNumber} readOnly hidden></input>
              <input type="text" name="signature" id={cbsSign.signature} value={cbsSign.signature} readOnly hidden></input>
              <input type="text" name="signed_date_time" id={cbsSign.signedDateTime} value={cbsSign.signedDateTime} readOnly hidden></input>
              <input type="text" name="signed_field_names" id={cbsSign.signedFieldNames} value={cbsSign.signedFieldNames} readOnly hidden></input>
              <input type="text" name="transaction_type" id={cbsSign.transactionType} value={cbsSign.transactionType} readOnly hidden></input>
              <input type="text" name="transaction_uuid" id={cbsSign.transactionUuid} value={cbsSign.transactionUuid} readOnly hidden></input>
              <input type="text" name="payment_method" id={cbsSign.paymentMethod} value={cbsSign.paymentMethod} readOnly hidden></input>
              <input type="text" name="unsigned_field_names" id={cbsSign.unsignedFieldNames} value={cbsSign.unsignedFieldNames} readOnly hidden></input>
              <input type="text" name="merchant_defined_data5" id={cbsSign.merchantDefinedData5} value={cbsSign.merchantDefinedData5} readOnly hidden></input>
              <input type="text" name="merchant_defined_data6" id={cbsSign.merchantDefinedData6} value={cbsSign.merchantDefinedData6} readOnly hidden></input>

              {/* unsigned */}
              <input type="text" name="card_cvn" id={cardCvn} value={cardCvn} readOnly hidden></input>
              <input type="text" name="card_expiry_date" id={cardExpiration} value={cardExpiration} readOnly hidden></input>
              <input type="text" name="card_number" id={cardNumber} value={cardNumber} readOnly hidden></input>
              <input type="text" name="card_type" id={cardType} value={cbsCardType} readOnly hidden></input>
              <GoogleReCaptchaProvider reCaptchaKey={reCaptchaSiteKey} >
                <GoogleReCaptcha 
                  onVerify={handleRecaptcha} 
                  refreshReCaptcha={refreshReCaptcha}
                />
              </GoogleReCaptchaProvider>
              {/* disabled if captcha doesnt pass + if button has been clicked once */}
              {
                (type === "timer") &&
                  <div>{errorMessage("cybs")}</div>
              }
              <button type="submit" 
                id="submitButton" 
                className={(!allowClick || !captchaPass) ? styles.buttonDisabled : styles.null} 
                disabled={!allowClick || !captchaPass}>
                SUBMIT PAYMENT
              </button>
          </form>
        </div>
      )
    }
    return ( 
      <div> Loading </div>
    )
  }

  const editPayment = () => {
    const redirectBack = () =>{
      navigate("/creditcardpayment.html");
    }
    return(
      <div className={styles.errSection}>
        {errorMessage("edit")}
        <button type="submit" id="editButton" onClick={redirectBack}>
          EDIT PAYMENT
        </button>
      </div>
    )

  }

  const displayView = () => {
    if (displayError === false) return load("regular");
    else if (displayError && timer) return load("timer");
    else return editPayment();
  }

  return (
    <div className={styles.CreditReview} data-testid="CreditReview" id="creditReview">
      {showHeader()}
      <div className={styles.CreditReviewContainer}>
        <div>
        {displayPaymentAmount()}
        <hr className={styles.linebreak} />
        <div className={styles.spacing}>
          <div className={styles.info}>
            {displayCreditPic()}
            <div>
              {displayPaymentInfo()}
            </div>
          </div>
        </div>
        <br/>
        <hr className={styles.linebreak} />
        {version === "remit" ? displayEditPayment() : null}       
        </div>
        {displayView()}
      
      </div>
    </div>
  );
}

export default CreditReview;
